export const CLASSES_LOAD = 'CLASSES_LOAD';
export const CLASSES_ADD_NEW = 'CLASSES_ADD_NEW';
export const CLASSES_SAVE = 'CLASSES_SAVE';
export const CLASSES_DELETE = 'CLASSES_DELETE';

export const TEACHERS_LOAD = 'TEACHERS_LOAD';

export const SUBJECTS_LOAD = 'SUBJECTS_LOAD';
export const SUBJECTS_ADD = 'SUBJECTS_ADD';

export const USER_LOAD = 'USER_LOAD';

export const MODULES_LOAD = 'MODULES_LOAD';

export const SURVEY_REFRESH = 'SURVEY_REFRESH';
export const POLL_REFRESH = 'POLL_REFRESH';


export const SSO_ENABLED = 'SSO_ENABLED'
export const PERMISSION_LOAD = 'PERMISSION_LOAD';

// Superadmin
export const GET_OPEN_INFO_LABEL_DATE = 'GET_OPEN_INFO_LABEL_DATE';

// Filters
export const FILTERS_LOAD = 'FILTERS_LOAD'